import React from "react";
import { fmt, fmt4, precoUnitReal, fmtPrecoUnit } from "../constants";

export default function AbaItens({ dados }) {
  const {
    busca, setBusca, gruposNaoVinculados, itensProducao, vincularGrupo,
    pedidos, loading, itensVinculados, aberto, setAberto,
    historicoItem, ultimaCompra, setModalEstoque, setEstoqueForm, confirmarPreco,
  } = dados;

  return (
    <>
      <div className="page-toolbar">
        <input className="form-input" style={{width:280}} placeholder="Buscar item de producao..." value={busca} onChange={e=>setBusca(e.target.value)}/>
        {gruposNaoVinculados.length>0&&<span style={{fontSize:12,color:"var(--z-danger-text)",fontWeight:600}}>{gruposNaoVinculados.length} tipos aguardando vinculacao</span>}
      </div>

      {gruposNaoVinculados.length>0&&!busca&&(
        <div className="card" style={{marginBottom:12,border:"1px solid #fde68a"}}>
          <div style={{padding:"10px 16px",background:"#fffbeb",borderBottom:"1px solid #fde68a",fontSize:13,fontWeight:600,color:"#92400e"}}>
            <i className="ti ti-alert-triangle"/> Aguardando vinculacao — {gruposNaoVinculados.length} tipos
          </div>
          <div className="table-wrapper">
            <table>
              <thead><tr>
                <th>Cod XML</th><th>Descricao XML</th>
                <th className="td-r">NFs</th>
                <th className="td-r">Ultimo preco unit</th>
                <th style={{minWidth:220}}>Vincular a</th>
              </tr></thead>
              <tbody>
                {gruposNaoVinculados.map(g=>{
                  const nfs=[...new Set(g.itens.map(ic=>{const p=pedidos.find(x=>x.id===ic.pedido);return p?.numero_nf;}).filter(Boolean))];
                  return(
                    <tr key={g.cod_xml||g.nome_xml}>
                      <td style={{fontSize:11,color:"var(--z-text-muted)",fontFamily:"monospace"}}>{g.cod_xml}</td>
                      <td>
                        <strong className="fs-12">{g.nome_xml}</strong>
                        <span style={{fontSize:10,color:"var(--z-text-muted)",marginLeft:6}}>{nfs.join(", ")}</span>
                      </td>
                      <td style={{textAlign:"right",fontSize:12}}>{g.itens.length}</td>
                      <td style={{textAlign:"right",fontSize:12,fontWeight:600}}>{fmtPrecoUnit(g.valor_unit,g.unidade)}</td>
                      <td onClick={e=>e.stopPropagation()}>
                        <select style={{fontSize:11,padding:"2px 6px",border:"1px solid var(--z-border)",borderRadius:4,width:"100%"}}
                          value="" onChange={e=>{if(e.target.value) vincularGrupo(g.itens,e.target.value);}}>
                          <option value="">-- Selecione --</option>
                          {itensProducao.slice().sort((a,b)=>a.nome.localeCompare(b.nome)).map(ip=>(
                            <option key={ip.id} value={ip.id}>{ip.codigo} — {ip.nome}</option>
                          ))}
                        </select>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}

      <div className="card">
        <div className="table-wrapper">
          {loading?<div className="table-empty">Carregando...</div>:
          !itensVinculados.length?<div className="table-empty">{busca?"Nenhum item encontrado.":"Nenhum item vinculado ainda."}</div>:
          <table>
            <thead><tr>
              <th>Codigo</th><th>Nome</th><th>Unidade</th>
              <th className="td-r">Preco Atual</th>
              <th className="td-r">Estoque</th>
              <th>Ultima Compra</th><th>Fornecedor</th>
              <th className="td-r">Valor NF (unit)</th>
              <th></th>
            </tr></thead>
            <tbody>
              {itensVinculados.map(ip=>{
                const ult=ultimaCompra(ip.id);
                const ped=ult?.pedido_obj;
                const open=aberto===ip.id;
                const hist=historicoItem(ip.id);
                const precoNFReal=ult?precoUnitReal(ult.valor_unit,ult.unidade):null;
                const diverge=precoNFReal!==null&&Math.abs(parseFloat(ip.preco_custo)-precoNFReal)>0.0001;
                return(
                  <React.Fragment key={ip.id}>
                    <tr className="tr-expandable" onClick={()=>setAberto(open?null:ip.id)}>
                      <td style={{fontFamily:"monospace",fontSize:11}}>{ip.codigo}</td>
                      <td><strong>{ip.nome}</strong></td>
                      <td className="fs-12 text-muted">{ip.unidade}</td>
                      <td style={{textAlign:"right",fontWeight:700,color:"var(--z-blue)"}}>R$ {fmt4(ip.preco_custo)}</td>
                      <td className="td-r" onClick={e=>e.stopPropagation()}>
                        <span style={{fontSize:12,fontWeight:600,color:parseFloat(ip.estoque||0)<=parseFloat(ip.estoque_minimo||0)&&parseFloat(ip.estoque_minimo||0)>0?"var(--z-danger-text)":"var(--z-success-text)"}}>
                          {parseFloat(ip.estoque||0).toLocaleString("pt-BR",{minimumFractionDigits:2,maximumFractionDigits:2})} {ip.unidade}
                        </span>
                        <button className="btn btn-secondary" style={{fontSize:10,padding:"1px 6px",marginLeft:4}}
                          onClick={()=>{setModalEstoque(ip);setEstoqueForm({tipo:"ENTRADA",quantidade:"",descricao:""});}}>
                          +/-
                        </button>
                      </td>
                      <td className="fs-12 text-secondary">
                        {ped?new Date(ped.data_emissao+"T12:00:00").toLocaleDateString("pt-BR"):"—"}
                      </td>
                      <td className="fs-12">{ped?.fornecedor_nome||"—"}</td>
                      <td style={{textAlign:"right",fontSize:12}}>
                        {ult?fmtPrecoUnit(ult.valor_unit,ult.unidade):"—"}
                      </td>
                      <td>
                        {diverge&&(
                          <span style={{fontSize:10,padding:"1px 6px",borderRadius:4,background:"#fef3c7",color:"#92400e",whiteSpace:"nowrap"}}>
                            ⚠ Diverge
                          </span>
                        )}
                      </td>
                    </tr>
                    {open&&(
                      <tr className="tr-dropdown">
                        <td colSpan={8}>
                          <div className="p-dropdown">
                            <div style={{fontSize:12,fontWeight:600,marginBottom:8,color:"var(--z-text-secondary)"}}>Historico de compras</div>
                            <table style={{width:"100%",fontSize:12}}>
                              <thead><tr className="bg-page">
                                <th className="td-l">Data</th>
                                <th className="td-l">NF</th>
                                <th className="td-l">Fornecedor</th>
                                <th className="td-r">Qtd</th>
                                <th className="td-r">Valor Unit (real)</th>
                                <th className="td-r">Total NF</th>
                                <th></th>
                              </tr></thead>
                              <tbody>
                                {hist.map((ic,idx)=>{
                                  const p=ic.pedido_obj;
                                  const isUltimo=idx===0;
                                  const realUnit=precoUnitReal(ic.valor_unit,ic.unidade);
                                  const divergeHist=Math.abs(parseFloat(ip.preco_custo)-realUnit)>0.0001;
                                  return(
                                    <tr key={ic.id} style={{borderBottom:"1px solid var(--z-border)",background:isUltimo?"#f0fdf4":""}}>
                                      <td className="td-p">{p?new Date(p.data_emissao+"T12:00:00").toLocaleDateString("pt-BR"):"—"}</td>
                                      <td className="td-mono">{p?.numero_nf}</td>
                                      <td style={{padding:"4px 8px",fontSize:11}}>{p?.fornecedor_nome}</td>
                                      <td className="td-r">{fmt(ic.quantidade)} {ic.unidade}</td>
                                      <td style={{padding:"4px 8px",textAlign:"right",fontWeight:isUltimo?700:400,color:isUltimo?"var(--z-blue)":""}}>
                                        {fmtPrecoUnit(ic.valor_unit,ic.unidade)}
                                      </td>
                                      <td className="td-r">R$ {fmt(ic.valor_total)}</td>
                                      <td className="td-p">
                                        {isUltimo&&divergeHist&&(
                                          <button className="btn btn-primary" style={{fontSize:10,padding:"2px 8px"}}
                                            onClick={async(e)=>{
                                              e.stopPropagation();
                                              const data = await confirmarPreco(ic.id);
                                              alert("Preco atualizado para "+fmtPrecoUnit(data.preco_custo_atualizado,"un")+" e propagado!");
                                            }}>
                                            Usar este preco
                                          </button>
                                        )}
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>}
        </div>
      </div>
    </>
  );
}
